<template>
  <div class="wrapper" style="background-color: #EFF3F8">
    <side-bar style="color:#020064">
      <sidebar-link
        to="/admin/dashboard"
        class="mx-4"
        style=" font-weight: bold;
          height: 50px;
          background-color: white;
          border-radius: 10px 10px 10px 10px;
        "
      >
        <span
          style="color: #000000"
          class="uk-margin-small-right"
          uk-icon="icon:home; ratio: 1.2"
        ></span>
        <p style="font-size: 1.3em; color: #000000">Backoffice</p>
      </sidebar-link>
      <br />

      <div>
        <p
          style="text-transform: capitalize; font-size: 1em; color : #ffffff; font-weight: bold;"
          class="uk-text-center uk-margin-remove"
        >
          {{ user.name }}
        </p>
        <p
          style="text-transform: uppercase; font-size: 0.7em; color : #ffffff; font-weight: 300;"
          class="uk-text-center"
        >
          {{ role }}
        </p>
      </div>

      <div>
        <b-list-group-item
          v-if="getRole == 2 || getRole == 3 || getRole == 4 || getRole == 5"
          button
          style="background-color: #FFFFFF; color: #5F5F5F; font-weight: bold; font-family: Poppins, sans-serif !important;"
        >
          <span
            class="uk-margin-small-right"
            style="color: #5F5F5F"
            uk-icon="icon:server; ratio: 1.2"
          ></span>
          Espace Livraison
        </b-list-group-item>
        <sidebar-link
          to="/admin/livraison/encours"
          style="margin-left: 1%"
          v-if="getRole == 2 || getRole == 3 || getRole == 4 || getRole == 5"
        >
          <p style="text-transform: capitalize; font-size: 1.4em">
            <span class="uk-badge">{{ countLivraisons.length }}</span>
            Livraisons en cours
          </p>
        </sidebar-link>
        <!-- <sidebar-link to="/admin/livraison/firestore" style="margin-left: 1%" v-if="getRole == 2 || getRole == 3 || getRole == 4 ||  getRole == 5">
          <p style="text-transform: capitalize; font-size: 1.4em">Colis Firestore</p>
        </sidebar-link> -->
        <!-- <sidebar-link to="/admin/livraison/termine" style="margin-left: 1%">
          <p style="text-transform: capitalize; font-size: 1.4em" v-if="getRole == 2 || getRole == 3 || getRole == 4 || getRole == 5">Livraisons terminées</p>
        </sidebar-link> -->
        <sidebar-link
          to="/admin/rapport/livreurs"
          style="margin-left: 1%"
          v-if="getRole == 5 || getRole == 4 || getRole == 3 || getRole == 2"
        >
          <p style="text-transform: capitalize; font-size: 1.4em">
            Rapport de livraisons
          </p>
        </sidebar-link>
        <!-- <sidebar-link to="/admin/livraison/allcolisfutur" style="margin-left: 1%" v-if="getRole == 5 || getRole == 4">
          <p style="text-transform: capitalize; font-size: 1.4em"><span class="uk-badge">  {{ countColisFutur.length }}</span> Colis futur </p>
        </sidebar-link> -->
        <!-- <sidebar-link to="/admin/boutiques/mestests" style="margin-left: 1%" v-if="getRole == 5 || getRole == 4">
          <p style="text-transform: capitalize; font-size: 1.4em">Mes tests</p>
        </sidebar-link> -->
        <!-- <sidebar-link to="/admin/livraison/savepoint" style="margin-left: 1%" v-if="getRole == 5 || getRole == 4">
          <p style="text-transform: capitalize; font-size: 1.4em">Historique de livraison</p>
        </sidebar-link> -->
      </div>

      <div v-if="getRole == 5">
        <b-list-group-item
          button
          style="background-color: #FFFFFF; color: #5F5F5F; font-weight: bold; font-family: Poppins, sans-serif !important;"
        >
          <span
            class="uk-margin-small-right"
            style="color: #5F5F5F"
            uk-icon="icon:users; ratio: 1.2"
          ></span>
          Gestion de comptes
        </b-list-group-item>
        <!-- <sidebar-link to="/admin/gestion/utilisateurs" style="margin-left: 1%">
          <p style="text-transform: capitalize; font-size: 1.4em">Les Utilisateurs 2.0</p>
        </sidebar-link> -->
        <sidebar-link to="/admin/clients" style="margin-left: 1%">
          <p style="text-transform: capitalize; font-size: 1.4em">
            <span class="uk-badge">{{ countUsers.length }}</span
            >Liste utilisateurs
          </p>
        </sidebar-link>
        <sidebar-link
          to="/admin/gestion/administrateurs"
          style="margin-left: 1%"
        >
          <p style="text-transform: capitalize; font-size: 1.4em">
            <span class="uk-badge"> {{ countAdmins.length }}</span>
            Administrateurs
          </p>
        </sidebar-link>
        <sidebar-link to="/admin/gestion/commerciaux" style="margin-left: 1%">
          <p style="text-transform: capitalize; font-size: 1.4em">
            <span class="uk-badge"> {{ countCommerciaux.length }}</span>
            Commerciaux
          </p>
        </sidebar-link>
        <sidebar-link to="/admin/gestion/logisticiens" style="margin-left: 1%">
          <p style="text-transform: capitalize; font-size: 1.4em">
            <span class="uk-badge"> {{ countLogisticiens.length }}</span>
            Logisticiens
          </p>
        </sidebar-link>
        <sidebar-link to="/admin/gestion/Livreurs" style="margin-left: 1%">
          <p style="text-transform: capitalize; font-size: 1.4em">
            <span class="uk-badge"> {{ countLivreursActifs.length - 2 }}</span>
            Livreurs
          </p>
        </sidebar-link>

        <!-- <sidebar-link to="/admin/gestion/superviseurs" style="margin-left: 1%">
          <p style="text-transform: capitalize; font-size: 1.4em">Superviseurs</p>
        </sidebar-link> -->
      </div>

      <div v-if="getRole == 2 || getRole == 5">
        <b-list-group-item
          button
          style="background-color: #FFFFFF; color: #5F5F5F; font-weight: bold; font-family: Poppins, sans-serif !important;"
        >
          <span
            class="uk-margin-small-right"
            style="color: #5F5F5F"
            uk-icon="icon:bag; ratio: 1.2"
          ></span>
          Espace boutique
        </b-list-group-item>
        <sidebar-link to="/admin/boutiques" style="margin-left: 1%">
          <p style="text-transform: capitalize; font-size: 1.4em">
            <span class="uk-badge"> {{ countBoutiques.length }}</span> Liste des
            boutiques
          </p>
        </sidebar-link>
      </div>

      <!-- <div v-if="getRole == 5 || getRole == 4">
        <b-list-group-item button style="background-color: #FFFFFF; color: #5F5F5F; font-weight: bold; font-family: Poppins, sans-serif !important;">
           <span class="uk-margin-small-right" style="color: #5F5F5F" uk-icon="icon: thumbnails; ratio: 1.2"></span>
          Gestions     
        </b-list-group-item>
        <sidebar-link to="/admin/pieceCaisse/accueil" style="margin-left: 1%">
          <p style="text-transform: capitalize; font-size: 1.4em">Pièce de caisse</p>
        </sidebar-link>
        <sidebar-link to="/admin/pointageHoraire/acceuil" style="margin-left: 1%">
          <p style="text-transform: capitalize; font-size: 1.4em">
            Pointage Horaire
          </p>
        </sidebar-link>
      </div> -->

      <div v-if="getRole == 5">
        <b-list-group-item
          button
          style="background-color: #FFFFFF; color: #5F5F5F; font-weight: bold; font-family: Poppins, sans-serif !important;"
        >
          <span
            class="uk-margin-small-right"
            style="color: #5F5F5F"
            uk-icon="icon:cog; ratio: 1.2"
          ></span>
          Paramètres
        </b-list-group-item>
        <sidebar-link to="/admin/tarifs" style="margin-left: 1%">
          <p style="text-transform: capitalize; font-size: 1.4em">Tarifs</p>
        </sidebar-link>
        <sidebar-link to="/admin/applications" style="margin-left: 1%">
          <p style="text-transform: capitalize; font-size: 1.4em">
            Applications
          </p>
        </sidebar-link>
      </div>

      <div>
        <b-list-group-item
          @click="signout"
          button
          style="background-color: #FFFFFF; color: #5F5F5F; font-weight: bold; font-family: Poppins, sans-serif !important;"
        >
          <span
            class="uk-margin-small-right"
            style="color: #5F5F5F"
            uk-icon="icon:sign-out; ratio: 1.2"
          ></span>
          Déconnexion
        </b-list-group-item>
      </div>
    </side-bar>

    <top-bar></top-bar>

    <div class="main-panel">
      <dashboard-content></dashboard-content>
    </div>
  </div>
</template>
<style>
@import "../../node_modules/uikit/dist/css/uikit.css";
.logo {
  display: none;
}
.navbar {
  background-image: linear-gradient(
    60deg,
    #32be8f,
    #38d39f,
    #32be8f
  ) !important;
}
</style>
<script>
import { db, dbstore, auth } from "../main";
import DashboardContent from "./Content.vue";
import TopBar from "./TopNavbar.vue";
import Swal from "sweetalert2";
export default {
  components: {
    DashboardContent,
    TopBar,
  },
  data() {
    return {
      activeNotifications: true,
      user: {},
      getRole: 0,
      role: "",
      countAdmins: [],
      countUsers: [],
      countLogisticiens: [],
      countCommerciaux: [],
      countLivraisons: [],
      countLivreursActifs: [],
      countRetours: [],
      countBoutiques: [],
      countColisFutur: [],
      Colis: [],
      boutiques: [],
    };
  },
  async created() {
    this.user = this.$store.getters.user.data;
    if (this.user == null) {
      this.$router.push({ path: "/login" });
    }
    this.getRole = this.$store.getters.user.data.role;
    if (this.getRole == 0) {
      this.role = "client";
    } else if (this.getRole == 1) {
      this.role = "livreur";
    } else if (this.getRole == 2) {
      this.role = "commercial";
    } else if (this.getRole == 3) {
      this.role = "superviseur";
    } else if (this.getRole == 4) {
      this.role = "logisticien";
    } else if (this.getRole == 5) {
      this.role = "administrateur";
    } else {
      return (this.role = "Erreur Système");
    }

    //Recuperations des livraisons
    db.ref("Colis Requetes").once("value", (dataSnapshot) => {
      const itemsArray = [];
      dataSnapshot.forEach((childSnapshot) => {
        itemsArray.push({});
        this.countLivraisons = itemsArray;
      });
    });
    //Recuperation des utilisateurs
    db.ref("users").once("value", (dataSnapshot) => {
      const itemsArray = [];
      dataSnapshot.forEach((childSnapshot) => {
        const childData = childSnapshot.val();
        itemsArray.push({
          id: childData.id,
          name: childData.name,
          role: childData.role,
        });
        this.countUsers = itemsArray;
      });
    });

    //Recuperation des utilisateurs
    db.ref("Colis Futur").once("value", (dataSnapshot) => {
      const itemsArray = [];
      dataSnapshot.forEach((childSnapshot) => {
        const childData = childSnapshot.val();
        itemsArray.push({
          id: childData.id,
          name: childData.name,
          role: childData.role,
        });
        this.countColisFutur = itemsArray;
      });
    });

    db.ref("users")
      .orderByChild("role")
      .equalTo("5")
      .once("value", (dataSnapshot) => {
        const itemsArray = [];
        dataSnapshot.forEach((childSnapshot) => {
          const childData = childSnapshot.val();
          itemsArray.push({
            id: childData.id,
            name: childData.name,
            role: childData.role,
          });
          this.countAdmins = itemsArray;
        });
      });

    //Recuperation des utilisateurs
    db.ref("users")
      .orderByChild("role")
      .equalTo("2")
      .once("value", (dataSnapshot) => {
        const itemsArray = [];
        dataSnapshot.forEach((childSnapshot) => {
          const childData = childSnapshot.val();
          itemsArray.push({
            id: childData.id,
            name: childData.name,
            role: childData.role,
          });
          this.countCommerciaux = itemsArray;
        });
      });

    //Recuperation des utilisateurs
    db.ref("users")
      .orderByChild("role")
      .equalTo("4")
      .once("value", (dataSnapshot) => {
        const itemsArray = [];
        dataSnapshot.forEach((childSnapshot) => {
          const childData = childSnapshot.val();
          itemsArray.push({
            id: childData.id,
            name: childData.name,
            role: childData.role,
          });
          this.countLogisticiens = itemsArray;
        });
      });

    //Recupération de livreur Actifs
    db.ref("users")
      .orderByChild("role")
      .equalTo("1")
      .once("value", (dataSnapshot) => {
        const itemsArray = [];
        dataSnapshot.forEach((childSnapshot) => {
          itemsArray.push({});
          this.countLivreursActifs = itemsArray;
        });
      });
    //Recuperation des boutiques
    dbstore
      .collection("boutiques")
      .get()
      .then((querySnapshot) => {
        const itemsArray = [];
        querySnapshot.forEach((childSnapshot) => {
          itemsArray.push({});
          this.countBoutiques = itemsArray;
        });
      });

    //Recuperation des retours
    dbstore
      .collection("livraison_retour")
      .get()
      .then((querySnapshot) => {
        const itemsArray = [];
        querySnapshot.forEach((childSnapshot) => {
          itemsArray.push({});
          this.countRetours = itemsArray;
        });
      });

    db.ref("Colis Requetes").once("value", (dataSnapshot) => {
      const itemsArray = [];
      dataSnapshot.forEach((childSnapshot) => {
        const childData = childSnapshot.val();
        this.Colis = childData;
        itemsArray.push({
          id: childData.id_colis,
          client_name: childData.client_name,
          client_phone: childData.client_phone,
          colis_type: childData.colis_type,
          depart_address: childData.depart_address,
          dest_address: childData.dest_address,
          dest_contact: childData.dest_contact,
          montant: childData.montant,
          nature: childData.nature,
          statut: childData.statut,
          livreur_id: childData.livreur_id,
          payment_method: childData.payment_method,
        });
      });
      this.Colis = itemsArray.reverse();
    });
  },
  methods: {
    signout() {
      auth.signOut().then(() => {
        Swal.fire({
          position: "center",
          icon: "success",
          title: '<span style="color:green">Vous etes déconnecté</span>',
          showConfirmButton: false,
          timer: 2500,
        });
        this.$router.push("/");
      });
    },
  },
};
</script>

<style>
.uk-badge {
  background: #fab83b;
}
</style>
